import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'checkIfSelected',
    standalone: false
})
export class CheckIfSelectedPipe implements PipeTransform {

  transform(id: number, selectedApartments: number[]): boolean {
    return selectedApartments.includes(id);
  }

}
